var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"ma-2",attrs:{"x-large":!_vm.$vuetify.breakpoint.smAndDown,"color":"success"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-play")]),_vm._v(" Próxima etapa ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }